<div class="row">
  <div class="col-12 p-0">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- <div *ngIf="windowScrolled" (click)="scrollToTop()" class="go-top-button bg-primary text-center">
  <div class="h-100 arrow-go-top">
    <em class="fa fa-arrow-up fa-3x"></em>
  </div>
</div> -->

<button *ngIf="windowScrolled" (click)="scrollToTop()" class="go-top-button bg-primary text-center" >
  <div class="h-100 arrow-go-top">
    <em class="fa fa-arrow-up fa-3x"></em>
  </div>
  <span class="sr-only">Ritorna all'inizio della pagina</span>
</button>

